/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Gameawards_Nogamestitle3Inputs */

const id_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada game yang diumumkan`)
};

const ms_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada permainan diumumkan`)
};

const da_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen spil annonceret endnu`)
};

const de_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Spiele angekündigt`)
};

const en_us2_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No games announced yet`)
};

const es_es2_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay juegos anunciados`)
};

const es_mx2_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay juegos anunciados`)
};

const fil_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang inanunsyong laro`)
};

const fr_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun jeu annoncé pour le moment`)
};

const it_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun gioco annunciato`)
};

const hu_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Még nincs bejelentett játék`)
};

const nl_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen games aangekondigd`)
};

const no_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen spill annonsert ennå`)
};

const pl_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ogłoszono jeszcze żadnych gier`)
};

const pt_br2_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo anunciado ainda`)
};

const pt_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo anunciado ainda`)
};

const ro_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încă nu s-au anunțat jocuri`)
};

const fi_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä ilmoitettuja pelejä`)
};

const sv_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga spel tillkännagivna än`)
};

const vi_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có game nào được công bố`)
};

const tr_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz oyun duyurulmadı`)
};

const cs_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím nebyly oznámeny žádné hry`)
};

const bg_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все още няма обявени игри`)
};

const ru_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игры пока не анонсированы`)
};

const uk_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ігор ще не анонсовано`)
};

const ar_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم الإعلان عن ألعاب بعد`)
};

const hi_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई गेम घोषित नहीं`)
};

const th_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีเกมที่ประกาศ`)
};

const ja_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ発表されたゲームはありません`)
};

const zh_cn2_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未公布游戏`)
};

const zh_hant1_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未公布遊戲`)
};

const ko_misc_gameawards_nogamestitle3 = /** @type {(inputs: Misc_Gameawards_Nogamestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 발표된 게임이 없습니다`)
};

/**
* | output |
* | --- |
* | "No games announced yet" |
*
* @param {Misc_Gameawards_Nogamestitle3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_gameawards_nogamestitle3 = /** @type {((inputs?: Misc_Gameawards_Nogamestitle3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Gameawards_Nogamestitle3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_gameawards_nogamestitle3(inputs)
	if (locale === "ms") return ms_misc_gameawards_nogamestitle3(inputs)
	if (locale === "da") return da_misc_gameawards_nogamestitle3(inputs)
	if (locale === "de") return de_misc_gameawards_nogamestitle3(inputs)
	if (locale === "en-US") return en_us2_misc_gameawards_nogamestitle3(inputs)
	if (locale === "es-ES") return es_es2_misc_gameawards_nogamestitle3(inputs)
	if (locale === "es-MX") return es_mx2_misc_gameawards_nogamestitle3(inputs)
	if (locale === "fil") return fil_misc_gameawards_nogamestitle3(inputs)
	if (locale === "fr") return fr_misc_gameawards_nogamestitle3(inputs)
	if (locale === "it") return it_misc_gameawards_nogamestitle3(inputs)
	if (locale === "hu") return hu_misc_gameawards_nogamestitle3(inputs)
	if (locale === "nl") return nl_misc_gameawards_nogamestitle3(inputs)
	if (locale === "no") return no_misc_gameawards_nogamestitle3(inputs)
	if (locale === "pl") return pl_misc_gameawards_nogamestitle3(inputs)
	if (locale === "pt-BR") return pt_br2_misc_gameawards_nogamestitle3(inputs)
	if (locale === "pt") return pt_misc_gameawards_nogamestitle3(inputs)
	if (locale === "ro") return ro_misc_gameawards_nogamestitle3(inputs)
	if (locale === "fi") return fi_misc_gameawards_nogamestitle3(inputs)
	if (locale === "sv") return sv_misc_gameawards_nogamestitle3(inputs)
	if (locale === "vi") return vi_misc_gameawards_nogamestitle3(inputs)
	if (locale === "tr") return tr_misc_gameawards_nogamestitle3(inputs)
	if (locale === "cs") return cs_misc_gameawards_nogamestitle3(inputs)
	if (locale === "bg") return bg_misc_gameawards_nogamestitle3(inputs)
	if (locale === "ru") return ru_misc_gameawards_nogamestitle3(inputs)
	if (locale === "uk") return uk_misc_gameawards_nogamestitle3(inputs)
	if (locale === "ar") return ar_misc_gameawards_nogamestitle3(inputs)
	if (locale === "hi") return hi_misc_gameawards_nogamestitle3(inputs)
	if (locale === "th") return th_misc_gameawards_nogamestitle3(inputs)
	if (locale === "ja") return ja_misc_gameawards_nogamestitle3(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_gameawards_nogamestitle3(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_gameawards_nogamestitle3(inputs)
	return ko_misc_gameawards_nogamestitle3(inputs)
});
export { misc_gameawards_nogamestitle3 as "misc.gameAwards.noGamesTitle" }